<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="1004030201">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="financePublicBO.ajax?cmd=getBankFlowDetailsthrows"
          :params="fullSearchData"
          bizName="银行流水数据导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            />
          </template>
          <!-- 常规列表项 end -->
          <el-table-column
            prop="control"
            label="操作"
            width="120"
            fixed="right"
          >
            <template slot-scope="scope">
              <section>
                <qx-permpisions permpisions="1004030202">
                  <span
                    class="primary cur"
                    @click="bankReceipt(scope.row.bankPreFlowNumber)"
                    >查看</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
    <BankReceiptDialog ref="bankReceiptDialog" />
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import BankReceiptDialog from './bankReceiptDialog';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  queryBankPayOutFlow,
  queryBankReceipt,
} from 'api/getPay';
import ExportBtn from 'components/exportBtn';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    BankReceiptDialog,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'flowId', label: '支付流水号', fixed: true },
          { prop: 'payBankAccName', label: '付款账户名' },
          { prop: 'payBankAccNo', label: '付款账号' },
          { prop: 'userName', label: '业务方' },
          { prop: 'accName', label: '收款账户名' },
          { prop: 'accNo', label: '收款账号' },
          { prop: 'businessName', label: '账号操作类型' },
          { prop: 'tranAmountStr', label: '支付金额' },
          { prop: 'respCodeName', label: '状态' },
          { prop: 'plateNumber', label: '车牌号' },
          { prop: 'busiCode', label: '业务单号' },
          { prop: 'customName', label: '客户名称' },
          { prop: 'busiIdName', label: '业务类型' },
          { prop: 'sourceName', label: '线路名称' },
          { prop: 'dependTime', label: '要求发车时间' },
          { prop: 'payTime', label: '发起支付时间' },
          { prop: 'completeTime', label: '付款完成时间' },
          { prop: 'respMsg', label: '备注' },
          { prop: 'orgName', label: '归属部门' },
          { prop: 'collectionUserName', label: '代收名称' },
          { prop: 'orderRemark', label: '订单备注' },
          { prop: 'isNeedBillName', label: '票据类型' },
          { prop: 'txnAmtDouble', label: '业务金额' },
          { prop: 'billServiceFeeDouble', label: '票据服务费' },
          { prop: 'appendFreightDouble', label: '附加运费' },
          { prop: 'accNameAndAccNo', label: '代付收款人' },
          { prop: 'respCodeName100', label: '代付状态' },
          { prop: 'payTime100', label: '代付完成时间' },
          { prop: 'receiptCode', label: '回单图片ID' },
          { prop: 'bankPreFlowNumber', label: '银行前置流水号' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryBankPayOutFlow,
    async bankReceipt (bankPreFlowNumber) {
      const resReceipt = await queryBankReceipt({
        bankPreFlowNumber,
      });
      if (!resReceipt.failed) {
        this.$refs.bankReceiptDialog.show(resReceipt);
      }
    },
  },
  // mounted () {
  //   this.$refs.bankReceiptDialog.show({
  //     url: 'http://www.baidu.com',
  //     bankPreFlowNumber: '123123123',
  //     code: '456456456',
  //   });
  // },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
